import { TreeNodeData } from '@/components/Elements/tree'

export const resolveLayerViewId = (
  activeLayer?: number | null,
  nodes: TreeNodeData[] = [],
): number | null => {
  if (!activeLayer) return null

  const node = nodes.find((n) => n.id === Number(activeLayer))
  if (!node) return Number(activeLayer)

  if (node.ownView) return node.id

  if (node.parent != null) {
    const parent = nodes.find((n) => n.id === Number(node.parent))
    if (parent?.ownView) return parent.id

    const siblingWithView = nodes.find(
      (n) => Number(n.parent) === Number(node.parent) && n.ownView,
    )
    if (siblingWithView) return siblingWithView.id

    return Number(node.parent)
  }

  const childWithView = nodes.find(
    (n) => Number(n.parent) === node.id && n.ownView,
  )

  return childWithView?.id ?? node.id
}
